module.exports = __webpack_public_path__ + "media/images/standout-efa80f5424944c0452147158eecdc962.svg";